// extracted by mini-css-extract-plugin
module.exports = {"size_text":"SizeHeader_size_text__V1UvP","size_heading_text":"SizeHeader_size_heading_text__Rq_Zy","size_value_text":"SizeHeader_size_value_text__VX0_O"};